import { render, staticRenderFns } from "./fa-icon.vue?vue&type=template&id=51cff7e8"
import script from "./fa-icon.vue?vue&type=script&lang=js"
export * from "./fa-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51cff7e8')) {
      api.createRecord('51cff7e8', component.options)
    } else {
      api.reload('51cff7e8', component.options)
    }
    module.hot.accept("./fa-icon.vue?vue&type=template&id=51cff7e8", function () {
      api.rerender('51cff7e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/general/fa-icon.vue"
export default component.exports